import { window } from 'browser-monads';

export const isElementInViewport = el => {
  if (typeof window !== `undefined`) {
    const rect = el.getBoundingClientRect();

    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) /* or $(window).height() */ &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */
    );
  }
};

export const isMobile = () => {
  if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    return true;
  }

  return false;
};

export const isIE = () =>
  window.navigator.userAgent.indexOf('MSIE ') > 0 || window.navigator.userAgent.indexOf('Trident/') > 0;

export const isIos = () => {
  const userAgent = window.navigator.userAgent.toLowerCase();
  return /iphone/.test(userAgent);
};

export const isIphoneXDisplay = () => {
  const ratio = window.devicePixelRatio || 1;
  const screen = {
    width: window.screen.width * ratio,
    height: window.screen.height * ratio,
  };
  return screen.width === 1125 && screen.height === 2436;
};

export const isInStandaloneMode = () => {
  const standaloneIos = window.navigator.standalone === true;
  const standaloneOther = window.matchMedia('(display-mode: standalone)').matches;

  return standaloneIos || standaloneOther;
};

export const removeAccents = string => string.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

export const createLink = string => removeAccents(string).replace(/\s/g, '-').toLowerCase();

export const getStudyLevelLink = level => {
  if (level === 'Bakalářský') {
    return 'bakalarske-studium';
  }

  if (level === 'Magisterský') {
    return 'magisterske-studium';
  }

  if (level === 'Doktorský') {
    return 'doktorske-studium';
  }

  return 'undefined!';
};
